import classnames from 'classnames';
import React, { ElementType, HTMLProps } from 'react';
import { DynamicComponent } from '../type';
import './Heading.scss';

type Props = {
  className?: string;
  level?: number;
};

export type HeadingProps<T = HTMLProps<HTMLHeadingElement>> = DynamicComponent<Props, T>;

export const Heading = function <T = HTMLProps<HTMLHeadingElement>>({
  level = 5,
  as: As = `h${level}` as ElementType,
  className,
  ...props
}: HeadingProps<T>) {
  const headingClassName = classnames('heading', `h${level}`, className);
  return <As className={headingClassName} {...props} />;
};
